<template>
  <div>
    <headerbox></headerbox>

    <div class="main index">
      <hotelhead></hotelhead>

      <div class="container">
        <div class="indexbanner">
          <img
            v-if="bannerimg && bannerimg.length > 0"
            :src="bannerimg[0].bannerimg"
            alt=""
          />
          <div class="text">
            <h1 v-if="hotelinfro && hotelinfro.hotelname">
              {{ hotelinfro.hotelname }}
            </h1>
            <p v-if="bannerimg && bannerimg.length > 0">
              {{ bannerimg[0].bannertext }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="introduce">
      <div class="main">
        <div class="container">
          <div class="introleft">
            <h3>酒店介绍</h3>
            <p v-if="hotelinfro && hotelinfro.content">
              {{ hotelintroduce }}
            </p>
          </div>
          <div class="intromap">
            <template v-if="hotelinfro && ((hotelinfro.gaode_lng && hotelinfro.gaode_lat) || (hotelinfro.baidu_lng && hotelinfro.baidu_lat))">
              <baidu-map
                class="map"
                :center="mapCenter"
                :zoom="16"
              >
                <bm-marker
                  :position="mapCenter"
                  :dragging="true"
                  @click="infoWindowOpen"
                >
                  <bm-info-window
                    :show="show"
                    @close="infoWindowClose"
                    @open="infoWindowOpen"
                  >
                    <h3 class="titles">{{ hotelinfro.hotelname }}</h3>
                    <p class="address">{{ hotelinfro.address }}</p>
                  </bm-info-window>
                </bm-marker>
              </baidu-map></template
            >
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="introtitle">
        <h3>酒店图片</h3>
        <p>探索精彩纷呈的酒店内部和周边风景</p>
      </div>
      <div class="hotel"> 
        <ul>
          <li v-for="(hotelpic, index) in hotelpic" :key="index">
            <img v-lazy="hotelpic.url" :alt="hotelpic.type_name" />
            <h3>{{ hotelpic.type_name }}</h3>
       
          </li>
        </ul>
      </div>
    </div>

    <footerbox></footerbox>
  </div>
</template>

<script>
import { setStorage, getStorage } from "@/common/until/until";

import footerbox from "components/content/footer";
import headerbox from "components/content/header";
import hotelhead from "components/content/hotelhead";

import { bannerlist } from "@/common/until/banner";
import { gethotelpic, gethotelphone } from "network/home";

export default {
  name: "index",
  data() {
    return {
      previousId: "1",
      hotel: {},
      bannerimg: [],
      hotelpic: {},
      show: true,
      phone: "400-6891109",
      descriptions: [
        "我们酒店为商务旅客提供完善、全面的客房设施，让您在忙碌的商务旅途中便携舒适。",
        "我们的酒店客房设施精心设计，满足商务旅客的需求，提供高速无线网络和舒适工作空间。",
        "我们酒店的客房设施全方位为商务旅客服务，提供便利的办公设施和舒适的床铺。",
        "我们酒店以精心设计的客房设施营造完美的商务旅行体验，提供宽敞办公区域和舒适床铺。",
      ],
    };
  },
  components: {
    footerbox,
    headerbox,
    hotelhead,
  },
  mounted() {
    this.bannerlist();
    this.getHotelpic();
  },
  methods: {
    bannerlist() {
      const cachedId = getStorage("cachedId");
      const lastDigit = cachedId
        ? parseInt(cachedId.toString().slice(-1))
        : null;

      this.bannerimg = bannerlist.slice(lastDigit, lastDigit + 1);
    },
    async getHotelpic() {
      const that = this;

      const hid =
        this.$route.query.hid || getStorage("cachedId") || "defaultHid";
      const method = "hotel.info";
      const agent_id = "7596562";
      const agent_md = "cee40804a5b2c83c";

      try {
        const res = await gethotelpic({
          hid,
          method,
          agent_id,
          agent_md,
        });
        const data = res.reqdata.reqdata.imgs || [];
        
        that.hotelpic = data.slice(0, 4);;
      } catch (error) {
        console.error("Error fetching hotel data:", error);
      }
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      this.show = true;
    },
    // GCJ-02（高德/谷歌）→ BD-09（百度）坐标系转换
    gcj02ToBd09(lng, lat) {
      const x_PI = (Math.PI * 3000.0) / 180.0;
      const z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
      const theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
      return {
        lng: z * Math.cos(theta) + 0.0065,
        lat: z * Math.sin(theta) + 0.006,
      };
    },
  },
  computed: {
    hotelintroduce() { 
      const filteredContent = this.hotelinfro.content.replace(/<br>/g, "");
      return filteredContent;
    },
    hotelinfro() {
      // 从Vuex中获取房间信息
      let roomInfo = this.$store.state.hotelinfro;

      // 如果Vuex中没有房间信息，则从LocalStorage中获取
      if (!roomInfo) {
        const localStorageRoomInfo = localStorage.getItem("hoteldata");
        if (localStorageRoomInfo) {
          roomInfo = JSON.parse(localStorageRoomInfo);
        }
      }

      return roomInfo;
    },
    mapCenter() {
      const info = this.hotelinfro;
      if (!info) return { lng: 0, lat: 0 };
      // 优先使用高德坐标（GCJ-02），转为百度 BD-09
      if (info.gaode_lng && info.gaode_lat) {
        return this.gcj02ToBd09(
          parseFloat(info.gaode_lng),
          parseFloat(info.gaode_lat)
        );
      }
      // 降级使用百度坐标
      if (info.baidu_lng && info.baidu_lat) {
        return {
          lng: info.baidu_lng,
          lat: info.baidu_lat,
        };
      }
      return { lng: 0, lat: 0 };
    },
  },
};
</script>
<style lang="less" scope>
.indexbanner {
  position: relative;
  margin-bottom: 40px;
  min-height: 200px;
  width: 100%;
  img {
    position: relative;
    z-index: 1;
    width: 100%;
  }
  .text {
    background: rgba(255, 255, 255, 0.35);
    height: 110px;
    position: absolute;
    right: 0;

    z-index: 5;
    top: 50%;
    margin-top: -55px;
    h1 {
      padding: 0 80px 0 30px;
      border-bottom: 2px solid #fff;
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 66px;
      letter-spacing: 8px;
    }
    p {
      line-height: 42px;
      font-size: 14px;
      font-weight: 400;
      color: #eeeeee;
      padding: 0 30px;
    }
  }
}

.introduce {
  width: 100%;
  background: #f1f1f1;
  margin-bottom: 50px;
  padding: 25px 0;
  .introleft {
    width: 500px;
    padding: 0 0px 30px 30px;
    h3 {
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      text-align: center;
      line-height: 60px;
    }
    p {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      height: 160px;
      overflow: hidden;
    }
  }
  .intromap {
    width: 512px;
    height: 280px;
  }
  .map {
    width: 100%;
    height: 100%;
  }
}

.introtitle {
  padding: 20px 0;
  text-align: center;
  h3 {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  p {
    font-size: 12px;

    font-weight: 400;
    color: #888888;
    line-height: 28px;
  }
}
.hotel ul {
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;
  li {
    width: 22%;
    h3 {
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 28px;
    }
    img {
      width: 100%;
      height: 170px;
    }
    p {
      font-size: 12px;
      font-weight: 400;
      color: #888888;
      line-height: 24px;
    }
  }
}
@media (min-width: 320px) and (max-width: 780px) {
  .index {
    .hotlehead {
      margin: 0;
    }
  }
  .indexbanner {
    width: 100%;
    margin: 0;
    .text {
      width: 100%;
      position: relative;
      top: 0;
      margin: 0;
      h1 {
        color: #333;
        padding: 0;
        letter-spacing: 0;
        font-size: 20px;
        line-height: 44px;
        text-align: center;
      }
      p {
        color: #888;
        padding: 0;
        text-align: center;
      }
    }
  }
  .introduce {
    .introleft {
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
    }
    .intromap {
      display: none;
    }
  }
  .hotel ul {
    flex-wrap: wrap;
    padding: 0 20px;
    li {
      width: 100%;
      img {
        height: auto;
      }
    }
  }
}
</style>
